<template>
    <div class="card-block">
      <div class="form-group row">
        <div class="col-md-10 pb-2">
          <h5>
            <strong><i class="fas fa-users"></i> Relacionamento</strong>
          </h5>
        </div>
        <div class="col-md-2">
          <a
            v-if="!isBusyRelacionamento"
            href="javascript:void(0);"
            @click="toggleBusyRelacionamento"
          >
            <i
              class="fas fa-eye-slash"
              style="font-size: 16px"
              v-b-tooltip.hover
              :title="'Minimizar Dados'"
            ></i>
          </a>
          <a
            v-else
            href="javascript:void(0);"
            @click="toggleBusyRelacionamento"
          >
            <i
              class="fas fa-eye"
              style="font-size: 16px"
              v-b-tooltip.hover
              :title="'Mostrar Dados'"
            ></i>
          </a>
        </div>
        <div class="table-responsive pt-2 pl-4 pr-4" v-if="phones && !isBusyRelacionamento">
          <table
            class="table table-hover"
            style="border: 1px solid #dcdede"
          >
            <thead class="thead-third" style="border: solid 1px #04a791; font-size: 12px">
              <tr>
                <th class="text-center">DOCUMENTO</th>
                <th class="text-center">NOME</th>
                <th class="text-center">TIPO PESSOA</th>
                <th class="text-center">DESCRIÇÃO</th>
              </tr>
            </thead>
            <tbody>
              <tr style="font-size: 11px" v-for="(obj, index) in personRelations" :key="index">
                <TableColumn
                  :IsText="true"
                  :status="1"
                  :value="obj.documentoPessoaRelacionada"
                  @Edit="openAssociatePageByRelacionamento(obj.documentoPessoaRelacionada)"
                />
                <TableColumn
                  :IsText="true"
                  :status="1"
                  :value="obj.nomePessoaRelacionada"
                  @Edit="openAssociatePageByRelacionamento(obj.documentoPessoaRelacionada)"
                />
                <TableColumn
                  :IsText="true"
                  :status="1"
                  :value="obj.tipopessoaRelacionada"
                  @Edit="openAssociatePageByRelacionamento(obj.documentoPessoaRelacionada)"
                />
                <TableColumn
                  :IsText="true"
                  :status="1"
                  :value="obj.descricaoPessoaRelacionada"
                  @Edit="openAssociatePageByRelacionamento(obj.documentoPessoaRelacionada)"
                />
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </template>

<script>
import AssociateRepository from '@/shared/http/repositories/business/associate.js'
import { toast } from '../../../../shared/utils/UIHelper'
import TableColumn from '../../../../components/forms/TableColumn.vue'

export default {
  components: {
    AssociateRepository,
    TableColumn
  },
  props: {
    personRelations: {
      type: Array
    },
    phones: {
      type: Array
    }
  },
  data () {
    return {
      isBusyRelacionamento: true
    }
  },
  methods: {
    toggleBusyRelacionamento () {
      this.isBusyRelacionamento = !this.isBusyRelacionamento
    },
    openAssociatePageByRelacionamento (document) {
      AssociateRepository.GetByDocument(document)
        .then(response => {
          response.data.content.length > 0
            ? this.openAssociatePage(response.data.content[0].id)
            : toast.error(' ATENÇÃO! Relacionamento não é um associado')
        })
        .catch(err => {
          console.error(err)
        })
    },
    openAssociatePage (associateId) {
      this.$router.replace({
        name: 'AssociatePage',
        params: {
          associateId: associateId,
          backUrl: 'Associate'
        }
      })
      this.$router.go()
    }
  }
}
</script>

  <style scoped>
  </style>



// WEBPACK FOOTER //
// src/views/private/associate/components/AssociateRelacionamento.vue